export default "__VITE_ASSET__D7a6ufnM__"